// src/hooks/useAchievements.ts
import { useMemo } from 'react';
import { UserStats } from '@/types';
import { getAchievements } from '@/lib/utils';

export const useAchievements = (stats: UserStats | null) => {
  const achievements = useMemo(() => {
    if (!stats) return [];
    return getAchievements(stats);
  }, [stats]);

  const unlockedCount = achievements.length;
  const totalAchievements = 12; // Total possible achievements

  return {
    achievements,
    unlockedCount,
    totalAchievements,
    progress: (unlockedCount / totalAchievements) * 100,
  };
};

